<div class="container text-center">
  <div class="text-center">
    <h1 i18n>About us</h1>
    <div class="about-us-subtitle">
      <p i18n="@@aboutUsSubtitle">Learn About Our Journey and Vision: Bringing You the Best Homemade Food from Talented Home Chefs.</p>
    </div>
    <div class="welcome-container">
      <div class="section-desc-container">
        <div class="section-title">
          <p i18n="@@aboutUsPageTitle">Welcome to Akl Bayti!</p>
        </div>
        <div class="section-text">
          <p i18n="@@aboutUsWelcomeMessage">At Akl Bayti, we believe in the power of homemade food. Our mission is to
            connect talented home chefs,
            local farms, and catering companies with customers who appreciate the quality, love, and care that goes into
            every homemade meal. We are more than just a marketplace; we are a community where food lovers and
            passionate cooks come together.</p>
        </div>
      </div>
      <div class="welcome-image"><img src="assets/about-us-logo.png"></div>
      <img class="spices-image" src="assets/merchant-landing-page/work-together-left-section.png">
    </div>
    <div class="who-we-are-container">
      <div class="welcome-image"><img src="assets/who-we-are.png"></div>
      <div class="who-we-are-desc-container">
        <div class="section-title">
          <p i18n>Who we are?</p>
        </div>
        <div class="section-text">
          <p i18n="@@whoWeAreMessage">Akl Bayti is a dedicated platform for homemade food enthusiasts. Our name, which
            means "My Home Food" in
            Arabic, reflects our commitment to bringing the warmth and authenticity of home-cooked meals to everyone.
            Whether you're a home chef looking to showcase your culinary skills or a customer searching for delicious,
            homemade dishes, Akl Bayti is the place for you.</p>
        </div>
      </div>
    </div>
    <div class="welcome-container">
      <div class="section-desc-container">
        <div class="section-title">
          <p i18n="@@ourVisionTitle">Our Vision</p>
        </div>
        <div class="section-text">
          <p i18n="@@ourVisionMessage">We envision a world where homemade food is celebrated and accessible to everyone.
            Our goal is to become the
            leading platform for homemade food, fostering a community where culinary talents are recognized and
            appreciated, and where customers can enjoy a variety of delicious, home-cooked meals..</p>
        </div>
      </div>
      <div class="welcome-image"><img src="assets/our-vision.png"></div>
      <img class="lemon-image" src="assets/merchant-landing-page/work-together-right-section.png">
    </div>
    <div class="our-mission-container">
      <img class="tomatoes" src="assets/large-tomatoes.png">
      <div class="welcome-image"><img src="assets/our-mission.png"></div>
      <div class="our-mission-desc-container">
        <div class="section-title">
          <p i18n="@@ourMissionTitle">Our Mission</p>
        </div>
        <p>
          <span class="pre-title" i18n="@@ourMissionMessagePreTitle">Empower Home Chefs:</span>
          <span i18n="@@ourMissionMessage">We provide a platform for home chefs to showcase their talents and reach a
            wider audience. By joining Akl Bayti, home chefs can focus on what they do best – creating delicious food –
            while we take care of the rest.
          </span>
        </p>
        <p>
          <span class="pre-title" i18n="@@ourMissionMessagePreTitle2">Promote Local Businesses:</span>
          <span i18n="@@ourMissionMessage2">
            We support local farms and catering companies by
            giving them a platform to reach more customers and grow their businesses.
          </span>
        </p>
      </div>
    </div>
    <div class="benefits-container">
      <div class="title-container">
        <img class="section-left-img" src="assets/merchant-landing-page/benefits-header-icon-1.png"/>
        <img class="section-right-img" src="assets/merchant-landing-page/benefits-header-icon-2.png"/>
        <img class="red-rectangle" src="assets/merchant-landing-page/rectangle-red-icon.png"/>
        <img class="yellow-rectangle" src="assets/merchant-landing-page/rectangle-yellow-icon.png"/>
        <p class="section-pre-header" i18n>Benefits</p>
        <h1 i18n="@@whatWeOfferTitle">What We Offer</h1>
      </div>
      <div class="meals-types-container">
        <div class="meal-item">
          <img src="assets/diverse-selection-icon.svg" alt="raw">
          <p class="meal-item-title" i18n="@@diverseSelection">Diverse Selection</p>
          <p class="meal-item-desc" i18n="@@diverseSelectionMessage">From savory dishes to sweet treats, our platform
            features a wide range of
            homemade foods crafted with love and care.</p>
        </div>
        <div class="meal-item">
          <img src="assets/quality-icon.svg" alt="cooked">
          <p class="meal-item-title" i18n="@@qualityAndAuthenticity">Quality & Authenticity</p>
          <p class="meal-item-desc" i18n="@@qualityAndAuthenticityMessage">Each home chef on our platform is passionate
            about their craft, ensuring that
            every meal is made with the highest quality ingredients and utmost attention to detail.</p>
        </div>
        <div class="meal-item">
          <img src="assets/customers-review-icon.svg" alt="hot">
          <p class="meal-item-title" i18n="@@customerReviews">Customer Reviews</p>
          <p class="meal-item-desc" i18n="@@customerReviewsMessage">Our community-driven review system helps customers
            make informed decisions and
            find the best homemade food available.</p>
        </div>
        <div class="meal-item">
          <img src="assets/friendly-icon.svg" alt="hot">
          <p class="meal-item-title" i18n="@@userFriendlyPlatform">User-Friendly Platform</p>
          <p class="meal-item-desc" i18n="@@userFriendlyPlatformMessage">Whether you’re a home chef or a customer, our
            platform is designed to be easy
            to navigate, making it simple to find what you’re looking for.</p>
        </div>
      </div>
    </div>
    <div class="community-container">
      <img class="onions" src="assets/merchant-landing-page/onions.png" alt="Onions">
      <img class="leaf" src="assets/merchant-landing-page/leaf.png" alt="Leaf">
      <div class="community-background">
        <p i18n="@@aboutJoinUsMessage">At Akl Bayti, we are always looking to expand our community. Whether you’re a
          home chef, a local
          farmer, a catering company, or a food lover, we invite you to join us on this delicious journey. Together, we
          can create a space where homemade food is cherished and enjoyed by all.</p>
        <button class="button-primary" routerLink="/merchants/signup" routerLinkActive="active" i18n>Join us now
        </button>
      </div>
    </div>
    <div class="email-us-container">
      <img src="assets/about-email-icon.svg" alt="logo"/>
      <p class="section-pre-header" i18n="@@contactUs">Contact Us</p>
      <h1 i18n="@@aboutUsCommunityTitle">We love hearing from our community!</h1>
      <p i18n="@@communityMessage">If you have any questions, feedback, or suggestions, please don’t hesitate to reach
        out to us at:</p>
      <p><a>hello@aklbayti.com</a></p>
    </div>
    <div class="stay-connected-details-container">
      <p class="section-pre-header" i18n>Stay Connected</p>
      <img class="follow-us-red-rectangle" src="assets/merchant-landing-page/rectangle-red-icon.png">
      <img class="yellow-rectangle" src="assets/merchant-landing-page/rectangle-yellow-icon.png">
      <div class="stay-connected-title">
        <h1 i18n="@@followUs">Follow Us</h1>
      </div>
      <p class="stay-connected-message" i18n="@@followUsMessage">Stay connected and follow us on social media for the
        latest updates, recipes,
        and stories from our community of home chefs and food lovers.</p>
      <div class="social-media-container">
        <a class="text-black" href="https://www.threads.net/@aklbaytimarketplace"><i class="bi-threads"></i></a>
        <a class="text-black" href="https://www.instagram.com/aklbaytimarketplace"><i class="bi-instagram"></i></a>
        <a class="text-black" href="https://www.facebook.com/aklbaytimarketplace"><i class="bi-facebook"></i></a>
      </div>
      <p class="follow-us-message" i18n="@@followUsMessageThanks">Thank you for being a part of Akl Bayti. Together, we
        can bring the joy of homemade
        food to everyone’s table.</p>
    </div>


  </div>
</div>
